import React from 'react'
import { connect } from 'react-redux'
import { bool } from 'prop-types'

import { stackableSurfaceItemType, renderItemType, furnitureItemType } from 'models/propTypes'

import { getNextStackableFurnitureData, getSelectedRenderItem } from 'models/compositions/selectors'

import CompositionStackableSurfaceItem from 'components/CompositionStackableSurfaceItem'

const CompositionStackableSurfaceItemContainer = (props) => <CompositionStackableSurfaceItem {...props} />

CompositionStackableSurfaceItemContainer.defaultProps = {
    visible: false,
    highlight: false,
    parent: null,
    incomingFurnitureData: null,
    selectedRenderItem: null,
}

CompositionStackableSurfaceItemContainer.propTypes = {
    plane: stackableSurfaceItemType.isRequired,
    visible: bool,
    highlight: bool,
    parent: renderItemType,
    incomingFurnitureData: furnitureItemType,
    selectedRenderItem: renderItemType,
}

const mapStateToProps = (state) => ({
    incomingFurnitureData: getNextStackableFurnitureData(state),
    selectedRenderItem: getSelectedRenderItem(state),
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CompositionStackableSurfaceItemContainer)
